import StorygameBG from '../assets/Audios/StoryGame.mp3';
export default {
  StorygameBG,
};
